// extracted by mini-css-extract-plugin
export default {"content":"adc__content--obnM4"};